/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ISaveStatus } from '../models/ISaveStatus';
import type { NoteUpdateDto } from '../models/NoteUpdateDto';
import type { Operation } from '../models/Operation';
import type { Patient } from '../models/Patient';
import type { PatientRequestSummary } from '../models/PatientRequestSummary';
import type { SetSitePrimaryCrcViewModel } from '../models/SetSitePrimaryCrcViewModel';
import type { Site } from '../models/Site';
import type { SiteCrc } from '../models/SiteCrc';
import type { SitePatientsViewModel } from '../models/SitePatientsViewModel';
import type { SiteSummaryViewModel } from '../models/SiteSummaryViewModel';
import type { SiteViewModel } from '../models/SiteViewModel';
import type { Study } from '../models/Study';
import type { User } from '../models/User';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class SiteService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param siteId
     * @returns SiteViewModel
     * @throws ApiError
     */
    public siteGet(
        siteId: number,
    ): Observable<SiteViewModel> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{siteId}',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param siteId
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public sitePatch(
        siteId: number,
        requestBody: Array<Operation>,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/api/sites/{siteId}',
            path: {
                'siteId': siteId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param siteId
     * @returns Site
     * @throws ApiError
     */
    public siteGetSiteServiceInfo(
        siteId: number,
    ): Observable<Site> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{siteId}/serviceinfo',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param siteId
     * @returns Study
     * @throws ApiError
     */
    public siteGetSiteStudyDetails(
        siteId: number,
    ): Observable<Array<Study>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{siteId}/studies',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param siteId
     * @returns User
     * @throws ApiError
     */
    public siteGetSiteUsersDetails(
        siteId: number,
    ): Observable<Array<User>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{siteId}/users',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param siteId
     * @returns SiteCrc
     * @throws ApiError
     */
    public siteGetSiteCrCsDetails(
        siteId: number,
    ): Observable<Array<SiteCrc>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{siteId}/users/crcdetails',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param siteId
     * @returns Patient
     * @throws ApiError
     */
    public siteGetSitePatients(
        siteId: number,
    ): Observable<Array<Patient>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{siteId}/patients',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param siteId
     * @returns SitePatientsViewModel
     * @throws ApiError
     */
    public siteGetSitePatientData(
        siteId: number,
    ): Observable<Array<SitePatientsViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{siteId}/patientdata',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param siteId
     * @returns SiteSummaryViewModel
     * @throws ApiError
     */
    public siteGetSiteSummary(
        siteId: number,
    ): Observable<SiteSummaryViewModel> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{siteId}/summary',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @returns SiteSummaryViewModel
     * @throws ApiError
     */
    public siteGetSiteSummaries(): Observable<Array<SiteSummaryViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/summaries',
        });
    }
    /**
     * @param studyId
     * @returns SiteSummaryViewModel
     * @throws ApiError
     */
    public siteGetStudySitesSummariesWithRequests(
        studyId: number,
    ): Observable<Array<SiteSummaryViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{studyId}/summaries',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns SiteSummaryViewModel
     * @throws ApiError
     */
    public siteGetStudySitesSummaries(
        studyId: number,
    ): Observable<Array<SiteSummaryViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{studyId}/details',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param siteId
     * @returns PatientRequestSummary
     * @throws ApiError
     */
    public siteGetSitePatientRequestSummaries(
        siteId: number,
    ): Observable<Array<PatientRequestSummary>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/sites/{siteId}/requestcounts',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public siteCreate(
        requestBody: Site,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/sites',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns string
     * @throws ApiError
     */
    public siteUpdate(
        requestBody: Site,
    ): Observable<Array<string>> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/sites',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param newStatus
     * @param siteId
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public siteChangeStatus(
        newStatus?: string | null,
        siteId?: number,
        requestBody?: Site,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/sites/changestatus',
            query: {
                'newStatus': newStatus,
                'siteId': siteId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param siteId
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public siteSetCrcUserType(
        siteId: number,
        requestBody: SetSitePrimaryCrcViewModel,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/api/sites/{siteId}/sitecrc/primary',
            path: {
                'siteId': siteId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param siteId
     * @param siteNoteId
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public siteUpdateSiteNote(
        siteId: number,
        siteNoteId: number,
        requestBody: NoteUpdateDto,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/sites/{siteId}/notes/{siteNoteId}',
            path: {
                'siteId': siteId,
                'siteNoteId': siteNoteId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
